class DeleteRecentSearchWordRequest {
  constructor(
              public readonly deleteAllYn: string,
              public readonly keyword: string) {
  }
}

export default DeleteRecentSearchWordRequest;